module.exports = __webpack_public_path__ + "img/15.cb319015.png";